export default __webpack_public_path__ + "static/media/fist-bump.90ef9d5a.gif";